import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { classNames } from 'primereact/utils';
import AuthLayout, { AuthField } from "../../modules/AuthLayout";
import { send, notify } from "../../../services/NotificationService";
import { resetPassword } from "../../../data/auth.service";

export default function Reset() {
    const [loading, setLoading] = useState(false);
    const [sentTo, setSentTo] = useState(null);

    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validate: (data) => {
            const errors = {};
            if (!data.email) {
                errors.email = "Veuillez saisir votre adresse e-mail.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            setLoading(true);
            try {
                const ret = await resetPassword(data);
                if (ret.status === 401) {
                    send("warning", ret.message);
                    notify();
                } else {
                    setSentTo(data.email);
                }
            } catch (error) {
                send("error", "L'envoi a échoué. Veuillez réessayer dans quelques instants.");
                notify();
            } finally {
                setLoading(false);
            }
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    if (sentTo) {
        return (
            <AuthLayout
                title="E-mail envoyé"
                subtitle={`Si un compte existe pour ${sentTo}, vous recevrez dans quelques minutes un lien pour choisir un nouveau mot de passe.`}
            >
                <div className="lk-auth__actions">
                    <Link to="/login" className="lk-btn lk-btn--primary" style={{ width: "100%" }}>
                        <i className="pi pi-arrow-left" aria-hidden="true"></i>
                        Retour à la connexion
                    </Link>
                </div>
                <p className="lk-auth__footer">
                    Vous ne recevez rien ? Vérifiez vos courriers indésirables ou <button type="button" className="lk-textbtn" onClick={() => setSentTo(null)}>réessayez</button>.
                </p>
            </AuthLayout>
        );
    }

    return (
        <AuthLayout
            title="Mot de passe oublié"
            subtitle="Indiquez votre adresse e-mail : nous vous enverrons un lien pour choisir un nouveau mot de passe."
        >
            <form onSubmit={formik.handleSubmit} noValidate>
                <AuthField id="email" label="Adresse e-mail" error={isFormFieldInvalid('email') ? formik.errors.email : null}>
                    <InputText
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        inputMode="email"
                        value={formik.values.email}
                        data-cy="emailInput"
                        onChange={(e) => formik.setFieldValue('email', e.target.value)}
                        className={classNames({ 'p-invalid': isFormFieldInvalid('email') })}
                    />
                </AuthField>

                <div className="lk-auth__actions">
                    <Button type="submit" label="Envoyer le lien" icon="pi pi-send" loading={loading} data-cy="connexionBtn" />
                </div>

                <div className="lk-auth__links">
                    <Link to="/login">
                        <i className="pi pi-arrow-left" aria-hidden="true"></i>
                        Retour à la connexion
                    </Link>
                </div>
            </form>
        </AuthLayout>
    );
}
